/**
 * Submit-drawer-aligned evidence validation for Assist create_submission
 * (SAD-899). Mirrors FileUploader.validateFile in ProjectList/FileUploader.
 */ const ALLOWED_MIME_TYPES = new Set([
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/msword',
    'application/vnd.ms-excel',
    'application/vnd.ms-powerpoint',
    'text/plain',
    'text/markdown',
    'text/html',
    'text/csv',
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
    'application/zip',
    'application/x-zip-compressed',
    'message/rfc822',
    'application/vnd.ms-outlook',
    'application/x-msoutlook'
]);
const MAX_FILE_SIZE = 250 * 1024 * 1024;
const EXTENSION_FALLBACK_ALLOWLIST = new Set([
    '.eml',
    '.msg'
]);
function getFileExtension(filename) {
    const dotIndex = filename.lastIndexOf('.');
    return dotIndex === -1 ? '' : filename.slice(dotIndex).toLowerCase();
}
/** Returns an error message if invalid, null if valid (drawer wording). */ export function validateDeliveryEvidenceMeta(filename, mimeType, sizeBytes) {
    if (sizeBytes === 0) return 'Empty file';
    if (sizeBytes > MAX_FILE_SIZE) return 'File exceeds 250MB limit';
    if (ALLOWED_MIME_TYPES.has(mimeType)) return null;
    if (EXTENSION_FALLBACK_ALLOWLIST.has(getFileExtension(filename))) return null;
    return `Unsupported file type: ${mimeType || 'unknown'}`;
}
export function strListFiles(params, ...keys) {
    for (const key of keys){
        const raw = params[key];
        if (Array.isArray(raw)) {
            return raw.map((v)=>String(v ?? '').trim()).filter(Boolean);
        }
        if (typeof raw === 'string' && raw.trim()) {
            return [
                raw.trim()
            ];
        }
    }
    return [];
}
